
import { Auth } from 'aws-amplify';
import { extractStructuredData } from '../../Content/verify_role';
import { parsData } from '../../Content/verify_role';
import { jwtDecode } from "jwt-decode";  // Importa de esta forma



export async function refresh_role() {


  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);  // Decodifica el JWT token
      console.log(decoded); // Muestra el contenido del payload del token
      return decoded;
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  };

  try {

    const cognitoUser = await Auth.currentAuthenticatedUser();
    const { refreshToken } = cognitoUser.getSignInUserSession();
    cognitoUser.refreshSession(refreshToken, (err, session) => {
      sessionStorage.setItem("getIdTokenRefresh", session?.idToken?.jwtToken)
      sessionStorage.setItem("getAccesTokenRefresh", session?.signInUserSession?.accessToken?.jwtToken);

    });
    const token = cognitoUser?.signInUserSession?.idToken?.jwtToken;
    if (token) {
      const decodedData = decodeToken(token);
      console.log(decodedData);
      var permisosUsuario = decodedData?.["custom:roles"];
      var permisoUsuarioReplace = permisosUsuario?.replace(/ /g, "");
      var permisos = permisoUsuarioReplace?.split(";");
      const res = extractStructuredData(permisos);
      console.log(res);
      const n_res = parsData(res);

      console.log("Antes de guardar:", JSON.stringify(n_res));
      sessionStorage.setItem("user_roles_data", JSON.stringify(n_res));
      console.log("Después de guardar:", sessionStorage.getItem("user_roles_data"));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

  } catch (error) {
    console.log(`Error: ${error}`);
    try {
      await Auth.signOut();
      alert('Sesión terminada.');
      window.location.href = "/";

    } catch (error) {
      console.log('Error al cerrar sesión:', error);
    }
  }

}



